// 引入 animate.css
import 'animate.css'

export default defineNuxtPlugin(() => {
  // 这个插件只是用来引入 animate.css，不需要返回任何内容
})
